import Media from "@/core/classes/models/Media";

export default class News {
  id;
  title;
  description;
  createdAt;
  medias = new Array();
  coverPath;
  constructor(data) {
    this.id = data?.id;
    this.title = data?.title;
    this.description = data?.description;
    this.createdAt = data?.created_at;
    data?.medias.map((item) => {
      let media = new Media(item);
      this.medias.push(media);
      if (media.isCover == 1) {
        this.coverPath = media.localPath;
      }
    });
  }
}
